
import { Component, Vue } from "vue-property-decorator";
import SetPushDialog from "./components/setPushDialog.vue";
import PagedListBase, {
  PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import {
  ChangPushInputDto,
  WxPushSettingService,
  PushSettingPageOutDto,
  Int32EntityDto,
  TeacherRangeClockDto,
  PushNotInSchoolInfoDto,
  TeacherInfoByNameOrPhone
} from "@/api/service-proxies";
import Pagination from "@/components/Pagination/index.vue";
import { Row } from "element-ui";
import moment from "moment";

class PageUserRequest extends PagedRequestDto {
  name!: string;
}

@Component({
  name: "User",
  components: {
    Pagination, SetPushDialog
  },
})
export default class extends PagedListBase<
  PageUserRequest,
  PushSettingPageOutDto
> {
  request = new PageUserRequest();
  payRecordVisible: boolean = false;
  changeVisible: boolean = false;
  teacherClickDialog = false;
  pushNotInSchoolInfoDto = new PushNotInSchoolInfoDto();
  notInSchoolPushDialog = false;
  updateTeacherClickDialog = false;
  updatepushNotInSchoolInfo = false;
  attdanceTeacherArray: TeacherInfoByNameOrPhone[] = []
  managerValue = "";
  selectTeacherIds = [];
  nameOrPhone = "";
  props = { multiple: true, value: "value" }; // 多级选择器配置多选
  teacherRangeClockDto = new TeacherRangeClockDto();
  private scoreService = new WxPushSettingService();
  form = {
    name: '',
    region: '',
    date1: '',
    date2: '',
    delivery: false,
    type: [],
    resource: '',
    desc: ''
  }
  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    this.scoreService
      .getTenantPushSettings(
        this.request.name,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        this.list = result.items;
        this.showPaging(result);
        this.isTableLoading = false;
      });
  }

  search() {
    this.refresh();
  }
  changeDate(val) {
    this.$forceUpdate();
  }
  changeSelect(value) {
    var item = this.attdanceTeacherArray.find(x => x.teacherAttendanceManagerUserId == value);
    if (item != undefined) {
      this.teacherRangeClockDto.teacherAttendanceManagerUserId = item.teacherAttendanceManagerUserId;
      this.teacherRangeClockDto.teacherAttendanceManagerUserName = item.teacherAttendanceManagerUserName + "_" + item.teacherAttendanceManagerUserPhone;
    } else {
      this.teacherRangeClockDto.teacherAttendanceManagerUserId = null;
      this.teacherRangeClockDto.teacherAttendanceManagerUserName = null;
    }
  }
  queryTeacher() {
    this.scoreService.getTeacherInfoByNameOrPhone(this.nameOrPhone, this.teacherRangeClockDto.tenantId)
      .then((res) => {
        this.attdanceTeacherArray = res;
      })
  }
  //更改配置
  changePushPermission(row) {
    var input = new ChangPushInputDto();
    input.tenantId = row.tenantId;
    input.isVipPush = row.isVipPush;
    input.isShowShop = row.isShowShop;

    this.scoreService.changeTenantPushSetting(input).then((result) => {
      if (result) {
        if (!input.isVipPush) {
          this.$notify.success("微信推送更改为只推送会员");
        } else {
          this.$notify.success("微信推送更改为全部推送");
        }
      } else {
        this.$notify.warning("数据更新失败，请稍后重试");
      }
    });
  }

  changeShowShop(row) {
    var input = new ChangPushInputDto();
    input.tenantId = row.tenantId;
    input.isShowShop = row.isShowShop;
    input.isVipPush = row.isVipPush;
    this.scoreService.changeTenantShowShop(input).then((result) => {
      if (result) {
        if (input.isShowShop) {
          this.$notify.success("该学校显示商城");
        } else {
          this.$notify.success("该学校不显示商城");
        }
      } else {
        this.$notify.warning("数据更新失败，请稍后重试");
      }
    });
  }

  changeIsOpenWorkerAddStudentInfo(row: PushSettingPageOutDto) {
    this.scoreService.changeIsOpenWorkerAddStudent(row)
      .then((res) => {
        this.$notify.success(row.isOpenWorkerAddStudent ? "修改成功(已打开)" : "修改成功(已关闭)");
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }

  changeIsNotVipShowFacerecord(row: PushSettingPageOutDto) {
    this.scoreService.changeIsNotVipShowFacerecord(row)
      .then((res) => {
        this.$notify.success(row.isNotVipShowFace ? "修改成功(已打开)" : "修改成功(已关闭)");
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }

  changeisOpenLeadeApproveSelf(row: PushSettingPageOutDto) {
    this.scoreService.changeIsOpenLeadeApproveSelf(row)
      .then((res) => {
        this.$notify.success(row.isNotVipShowFace ? "修改成功(已打开)" : "修改成功(已关闭)");
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }

  changeisReleaseNeedApproval(row: PushSettingPageOutDto) {
    this.scoreService.changeIsReleaseNeedApproval(row)
      .then((res) => {
        this.$notify.success(row.isReleaseNeedApproval ? "修改成功(已打开)" : "修改成功(已关闭)");
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }

  changeIspushSignStudent(row: PushSettingPageOutDto) {
    this.scoreService.changeIspushSignStudent(row)
      .then((res) => {
        this.$notify.success(row.ispushSignStudent ? "修改成功(已打开)" : "修改成功(已关闭)");
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }
  changeIsUpdateFace(row: PushSettingPageOutDto) {
    this.scoreService.changeIsUpdateFace(row)
      .then((res) => {
        this.$notify.success(row.ispushSignStudent ? "修改成功(已打开)" : "修改成功(已关闭)");
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }

  changeValue(row: PushSettingPageOutDto, type: number,valueBeloane) {
    var Y = "修改成功(已打开)";
    var N = "修改成功(已关闭)";
    row.type = type
    this.scoreService.changeValue(row)
      .then((res) => {
        this.$notify.success(valueBeloane ? Y : N);
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }

  changeisMessageLogin(row: PushSettingPageOutDto) {
    this.scoreService.changeIsMessageLogin(row)
      .then((res) => {
        this.$notify.success(row.isMessageLogin ? "修改成功(已打开)" : "修改成功(已关闭)");
      })
      .catch((e) => {
        this.$notify.warning("修改失败");
      })
  }


  changeShowTeacherDuty(row) {
    var item = new Int32EntityDto();
    item.id = row.tenantId;
    this.scoreService.changeTeacherDutyBefore(item);
  }

  handleInput(value) {
    // 使用正则表达式匹配数字和小数点
    const regex = /^(\d+)?(\.\d+)?$/;
    // 如果输入值不符合规定的正则表达式，则将其设置为上一个合法的值
    if (!regex.test(value)) {
      this.$message.warning("只能输入整数或者小数");
    }
  }

  //获取定时推送学生未到校设置
  getPushNotInSchool(id: number) {
    this.notInSchoolPushDialog = true;
    this.scoreService
      .getPushNotInSchoolInfo(id)
      .then((res) => {
        this.pushNotInSchoolInfoDto = res;
      })
      .catch((e) => {
        this.$message.error("获取数据失败");
      })
      .finally(() => { });
  }
  // 推给班主任
  getPushToMaster(id:number) {
    (this.$refs.setPushDialogRef as SetPushDialog).open(id)
  }
  //更新定时推送学生未到校设置
  updatePushNotInSchool() {
    this.updatepushNotInSchoolInfo = true;
    if (this.pushNotInSchoolInfoDto.isPushNotInSchool == true && this.pushNotInSchoolInfoDto.pushTimeStr == "") {
      this.$message.error("时间不能为空");
      return;
    }
    this.scoreService
      .updatePushNotInSchool(this.pushNotInSchoolInfoDto)
      .then((res) => {
        this.$message.success("设置成功");
      })
      .catch((e) => {
        this.$message.error("设置失败");
      })
      .finally(() => {
        this.updatepushNotInSchoolInfo = false;
      });
  }


  //获取教师范围打卡设置
  getRangeClickDto(id: number) {
    this.teacherClickDialog = true;
    this.scoreService
      .getTeacherRangeChick(id)
      .then((res) => {
        this.teacherRangeClockDto = res;
        res.teacherIds.forEach((e) => {
          var fastLeve = res.teacherGroupDto.find(x => x.children.find(y => y.value == e));
          this.selectTeacherIds.push([fastLeve.value, e])
        })
      })
      .catch((e) => {
        this.$message.error("获取数据失败");
      })
      .finally(() => { });
  }

  //更新教师范围打卡设置
  updateRangeClickDto() {
    this.updateTeacherClickDialog = true;
    this.teacherRangeClockDto.teacherIds = [];
    this.selectTeacherIds.forEach((e) => {
      this.teacherRangeClockDto.teacherIds.push(e[1])
    })
    this.scoreService
      .updateTeacherRangeChick(this.teacherRangeClockDto)
      .then((res) => {
        this.$message.success("修改成功");
      })
      .catch((e) => {
        this.$message.error("修改失败");
      })
      .finally(() => {
        this.updateTeacherClickDialog = false;
        this.teacherClickDialog = false;
      });
  }
}
